import { render } from "./ProductGrid.vue?vue&type=template&id=15b8b86c"
import script from "./ProductGrid.vue?vue&type=script&lang=js"
export * from "./ProductGrid.vue?vue&type=script&lang=js"
script.render = render

export default script